/*
 * @Author: Li, Yu Jia
 * @Date: 2019-12-02 11:35:55
 * @Last Modified by: Li, Yu Jia
 * @Last Modified time: 2020-02-13 19:09:31
 */

import * as actions from './actions';
import * as logics from './logics';
import * as selectors from './selectors';

import reducers from './reducers';

const imprintArea = { reducers, logics, actions, selectors };
export default imprintArea;
